export const RESOURCE_LIST_STATE_PREFIX = 'admin:v3:resource:list-state';

export interface ParsedResourcePath {
  syllabus_id?: number;
  course_id?: number;
  levels: Record<string, number>;
}

export function getResourceListStateStorageKey(resourceType: string): string {
  return `${RESOURCE_LIST_STATE_PREFIX}:${resourceType}`;
}

export function readDrivePathIdsFromListState(resourceType: string): number[] {
  try {
    const raw = sessionStorage.getItem(getResourceListStateStorageKey(resourceType));
    if (!raw) {
      return [];
    }
    const payload = JSON.parse(raw) as { driveNavPathIds?: unknown };
    if (!Array.isArray(payload.driveNavPathIds)) {
      return [];
    }
    return payload.driveNavPathIds
      .map((id) => +id)
      .filter((id) => !Number.isNaN(id) && id > 0);
  } catch {
    return [];
  }
}

export function parseDrivePathParam(path: string | null | undefined): ParsedResourcePath {
  const result: ParsedResourcePath = { levels: {} };
  if (!path?.trim()) {
    return result;
  }
  const pathParts = path.split('/').filter((part) => part.trim());
  if (pathParts.length >= 1) {
    result.syllabus_id = parseInt(pathParts[0], 10);
  }
  if (pathParts.length >= 2) {
    result.course_id = parseInt(pathParts[1], 10);
  }
  for (let i = 2; i < pathParts.length; i++) {
    result.levels[`level_${i}`] = parseInt(pathParts[i], 10);
  }
  return result;
}

export function pathIdsToDrivePathParam(pathIds: number[]): string | null {
  const ids = pathIds.filter((id) => !Number.isNaN(id) && id > 0);
  return ids.length ? ids.join('/') : null;
}
